import { Box, Typography } from '@mui/material';
import { useContext } from 'react';
import '../template.module.css';
import BlockNameHeading from './BlockNameHeading';

import { ReportTemplatesContext } from '..';
import { RemoveBlockSVG } from './HelperSVGs';

export function GenericBlock({ title, sectionKey }) {
  const { removeBlock } = useContext(ReportTemplatesContext);
  const styles = {
    text: {
      fontFamily: 'Lato',
      lineHeight: '20px',
      textAlign: 'center',
    },
  };

  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor: '#F9F9F9',
        paddingY: '1.25rem',
        paddingX: '1rem',
        borderRadius: '1rem',
        display: 'flex',
        gap: '1rem',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Text */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.75rem',
        }}
      >
        <Typography
          sx={[
            styles.text,
            {
              fontSize: '1.1rem',
              fontWeight: 500,
            },
          ]}
        >
          {title}
        </Typography>

        <Typography
          sx={[
            styles.text,
            {
              fontSize: '1.4rem',
              fontWeight: 900,
            },
          ]}
        >
          {{
            crime: '0.45x',
            expansion: '-0.96%',
            income: '$173,568',
            annual_income: '-0.04 %',
            rent: '$4,544',
            msa: '60',
          }[sectionKey] || null}
          {{
            'Price Appreciation Since 2011': '2.90x',
            'Background Rate of Appreciation (1990 - present)':
              '12.27% per year',
          }[title] || null}
        </Typography>
        {sectionKey !== 'income' ||
          (sectionKey !== 'rent' && (
            <Typography
              sx={[
                styles.text,
                {
                  fontSize: '1rem',
                  fontWeight: 500,
                },
              ]}
            >
              {
                {
                  crime: 'National Average',
                  expansion: 'Declining',
                }[sectionKey]
              }
            </Typography>
          ))}
      </Box>
      {/* SVGs */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.75rem',
        }}
      >
        {sectionKey !== 'hpi' &&
          sectionKey !== 'msa' &&
          sectionKey !== 'income' &&
          sectionKey !== 'annual_income' && (
            <Box
              sx={{
                cursor: 'pointer',
              }}
              onClick={() => {
                removeBlock(title, sectionKey);
              }}
            >
              <RemoveBlockSVG />
            </Box>
          )}
      </Box>
    </Box>
  );
}

export function GenericIncomeBlock({ title, sectionKey, blocks }) {
  const { removeBlock } = useContext(ReportTemplatesContext);
  const styles = {
    rowContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '1rem',
      width: '100%',
    },
  };

  return (
    <Box
      sx={{
        flex: '1 0 100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        alignItems: 'center',
      }}
    >
      <BlockNameHeading title={title} />
      {blocks.map((blockRow, rowIndex) => (
        <Box key={rowIndex} sx={styles.rowContainer}>
          {blockRow.map((block, blockIndex) => (
            <GenericBlock
              key={blockIndex}
              title={block}
              sectionKey={sectionKey}
            />
          ))}
        </Box>
      ))}
      <Box
        sx={{
          cursor: 'pointer',
          alignSelf: 'center',
        }}
        onClick={() => {
          removeBlock(title, 'income');
        }}
      >
        <RemoveBlockSVG />
      </Box>
    </Box>
  );
}

export function GenericAppreciationBlock({ title }) {
  const { removeBlock } = useContext(ReportTemplatesContext);
  return (
    <Box
      sx={{
        flex: '1 0 100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '.75rem',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '.5rem',
        }}
      >
        <GenericBlock title={title} sectionKey={'hpi'} />
        <GenericBlock title={title} sectionKey={'hpi'} />
        <GenericBlock title={title} sectionKey={'hpi'} />
      </Box>
      <Box
        sx={{
          cursor: 'pointer',
          alignSelf: 'center',
        }}
        onClick={() => {
          removeBlock(title, 'hpi');
        }}
      >
        <RemoveBlockSVG />
      </Box>
    </Box>
  );
}
